import React from "react";
import ExportModal from "../../components/ExportModal";
import {
  buildCompanyExportFilename,
  buildCompanyFilterSummary,
  COMPANY_EXPORT_COLUMNS,
  COMPANY_EXPORT_TABS,
  fetchAllCompanies,
} from "./companyExport";

const ExportCompanyModal = ({
  activeModal,
  setActiveModal,
  defaultTab = "active",
  searchTerm = "",
  joinedFromFilter = "ALL",
  pageScope = null,
}) => (
  <ExportModal
    activeModal={activeModal}
    setActiveModal={setActiveModal}
    title="Export Companies"
    tabs={COMPANY_EXPORT_TABS}
    defaultTab={defaultTab}
    columns={COMPANY_EXPORT_COLUMNS}
    entityLabel={{ one: "company", many: "companies" }}
    pageScope={pageScope}
    filterSummary={(tab) =>
      buildCompanyFilterSummary({ tab, searchTerm, joinedFrom: joinedFromFilter })
    }
    fetchRows={({ tab, fromPage, toPage, pageSize, onProgress, isCancelled }) =>
      fetchAllCompanies({
        tab,
        searchTerm,
        joinedFrom: joinedFromFilter,
        fromPage,
        toPage,
        pageSize,
        onProgress,
        isCancelled,
      })
    }
    buildFilename={(tab, scopeParts) =>
      buildCompanyExportFilename({ tab, searchTerm, joinedFrom: joinedFromFilter, scopeParts })
    }
  />
);

export default ExportCompanyModal;
